<template>
  <ul class="filters__list">
    <li v-bind:class="['filters__list-group', filter.id]" v-for="(filter, i) in initFilters" :key="i">
      <button
          class="filters__list-group__toggle "
          :class="{'filters__list-group__toggle--active': initFilters[i].isExpanded}"
          v-on:click="handleOnClickButton(i)"
          :aria-controls="`filter_${filter.id}`"
          :aria-expanded="initFilters[i].isExpanded">{{filter.label}}</button>
      <div v-show="initFilters[i].isExpanded" :id="`filter_${filter.id}`" role="region" tabindex="-1">
        <component v-bind="{...filter.fieldData, value: value[filter.id], is: filter.component}" v-on:input="(value) => setValue(filter.id, value)"></component>
      </div>
    </li>
  </ul>
</template>

<script type="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import BoxesList from "./select/BoxesList";
import Slider from './Slider';

interface FiltersGroup {
  name: string,
  options: Array<any>,
  component: string,
  fieldData: any,
  isExpanded: boolean,
}

@Component({
  components: {BoxesList, Slider}
})
export default class Filters extends Vue {
  private initFilters: FiltersGroup[] = [];

  @Prop({default: () => [], type: Array}) filters: any[];
  @Prop({default: () => {}, type: Object}) value: Record<string, string|number|Array<string|number>>;

  private mounted() {
    this.updateInitFilters();
  }

  @Watch('filters')
  private updateInitFilters() {
    this.initFilters = this.filters.map((item) => {
      item.isExpanded = false;
      return item;
    });
  }

  private setValue(filterId, value) {
    this.value[filterId] = value;

    this.$emit('input', this.value);
  }

  public handleOnClickButton(i) {
    this.$set(this.initFilters, i, {...this.initFilters[i], isExpanded: !this.initFilters[i].isExpanded})
  }
}
</script>